import styled from 'styled-components';

const Header = styled.div`
  &&& {
    background-color: ${props => props.custom ? '#F0A30A' : '#49C4A3'}
  }
`;

const Body = styled.div`
  &&& {
    padding: ${props => props.show ? '10px' : '0'};
    max-height: ${props => props.show ? 'none' : '0'};
    transition: max-height 1s;
  }
`;

export {
  Header,
  Body
};